import {createReducer, on} from '@ngrx/store';
import * as ClientDetailsActions from './client-details.actions';
import {ClientDetails} from "../../../../models/client-details";
import {Filter} from "../../../../models/filter";
import { FetchClientNameFailure, FetchClientNameRequest, FetchClientNameSuccess } from "./client-details.actions";

export interface ClientDetailsState {
  clientDetails: {
    loading: boolean,
    details: ClientDetails
  },
  clientStatusFilter: Filter,
  organizationTypeFilter: Filter
  clientName: {
    name: string
  }
}

const initialState: ClientDetailsState = {
  clientDetails: {
    loading: false,
    details: null,
  },
  clientStatusFilter: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  organizationTypeFilter: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  clientName: {
    name: ''
  }
};

export const reducer = createReducer(
  initialState,

  // Clear state
  on(ClientDetailsActions.ClearState, (state) => initialState),

  // FETCH CLIENT DETAILS
  on(ClientDetailsActions.FetchClientDetailsRequest, (state) => ({
    ...state,
    clientDetails: {
      ...initialState.clientDetails,
      loading: true
    }
  })),
  on(ClientDetailsActions.FetchClientDetailsSuccess, (state, props) => ({
    ...state,
    clientDetails: {
      details: props.clientDetails,
      loading: false
    },
    clientName: {
      name: props.clientDetails['name']
    }
  })),
  on(ClientDetailsActions.FetchClientDetailsFailure, (state) => ({
    ...state,
    clientDetails: {
      ...state.clientDetails,
      loading: false
    }
  })),

  // ADD CLIENT DETAILS
  on(ClientDetailsActions.AddClientDetailsRequest, (state) => ({
    ...state,
    clientDetails: {
      ...initialState.clientDetails,
      loading: true
    }
  })),
  on(ClientDetailsActions.AddClientDetailsSuccess, (state, props) => ({
    ...state,
    clientDetails: {
      details: props.clientDetails,
      loading: false
    },
    clientName: {
      name: props.clientDetails?.name || '',
      loading: false
    }
  })),
  on(ClientDetailsActions.AddClientDetailsFailure, (state) => ({
    ...state,
    clientDetails: {
      ...state.clientDetails,
      loading: false
    }
  })),

  // UPDATE CLIENT DETAILS
  on(ClientDetailsActions.UpdateClientDetailsRequest, (state) => ({
    ...state,
    clientDetails: {
      ...initialState.clientDetails,
      loading: true
    }
  })),
  on(ClientDetailsActions.UpdateClientDetailsSuccess, (state, props) => ({
    ...state,
    clientDetails: {
      details: props.clientDetails,
      loading: false
    },
    clientName: {
      name: props.clientDetails?.name || '',
      loading: false
    }
  })),
  on(ClientDetailsActions.UpdateClientDetailsFailure, (state) => ({
    ...state,
    clientDetails: {
      ...state.clientDetails,
      loading: false
    }
  })),

  // FETCH CLIENT STATUS
  on(ClientDetailsActions.FetchClientStatusFilterRequest, (state) => ({
    ...state,
    clientStatusFilter: {
      ...initialState.clientStatusFilter,
      loading: true
    }
  })),
  on(ClientDetailsActions.FetchClientStatusFilterSuccess, (state, props) => ({
    ...state,
    clientStatusFilter: {
      ...props.clientStatusFilter,
      loading: false
    }
  })),
  on(ClientDetailsActions.FetchClientStatusFilterFailure, (state) => ({
    ...state,
    clientStatusFilter: {
      ...state.clientStatusFilter,
      loading: false
    }
  })),

  // FETCH ORG TYPE LIST
  on(ClientDetailsActions.FetchOrganizationTypeFilterRequest, (state) => ({
    ...state,
    organizationTypeFilter: {
      ...initialState.organizationTypeFilter,
      loading: true
    }
  })),
  on(ClientDetailsActions.FetchOrganizationTypeFilterSuccess, (state, props) => ({
    ...state,
    organizationTypeFilter: {
      ...props.organizationTypeFilter,
      loading: false
    }
  })),
  on(ClientDetailsActions.FetchOrganizationTypeFilterFailure, (state) => ({
    ...state,
    organizationTypeFilter: {
      ...state.organizationTypeFilter,
      loading: false
    }
  })),

  // FETCH CLIENT NAME
  on(FetchClientNameRequest, (state) => ({
    ...state,
    clientName: initialState.clientName
  })),
  on(FetchClientNameSuccess, (state, props) => ({
    ...state,
    clientName: {
      name: props.name
    }
  })),
  on(FetchClientNameFailure, (state) => ({
    ...state,
    clientName: initialState.clientName
  })),
);
